import PropTypes from "prop-types";
import { ReactComponent as Wave } from "../../../../assets/img/background/wave.svg";

const PageTitle = ({ title, icon, description }) => {
  return (
    <>
      <div className="lg:hidden absolute inset-x-0 top-12 sm:top-8 h-0">
        <Wave className="fill-current text-gray-200 w-full h-auto" />
      </div>
      <div
        className="relative bg-primary border border-white  rounded-lg px-3 py-2 shadow-xl"
        id="page-title"
      >
        <div className="flex flex-row sm:flex-col lg:flex-row  space-x-3 sm:space-x-0 lg:space-x-4 items-center">
          <div>{icon}</div>
          <div className="text-white text-left sm:text-center lg:text-left">
            <h1 className="text-base sm:text-xl lg:text-2xl font-semibold sm:font-normal ">
              {title}
            </h1>
            <p className="text-xs sm:text-sm max-w-lg lg:max-w-max text-white text-opacity-75">
              {description}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element,
  description: PropTypes.string.isRequired,
};
export default PageTitle;
